import { render } from "./ContentEditor.vue?vue&type=template&id=7f784dc1&scoped=true"
import script from "./ContentEditor.vue?vue&type=script&lang=js"
export * from "./ContentEditor.vue?vue&type=script&lang=js"

import "./ContentEditor.vue?vue&type=style&index=0&id=7f784dc1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f784dc1"]])

export default __exports__